import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const Container = styled.div`
    height: 100%;
    max-height: 2.3rem;
    position: relative;
    z-index: ${({ zIndex }) => zIndex};
`;
